//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import newApi from '@/utils/newModuleApi'
import FeatureGuidePanel from '@/components/new/FeatureGuidePanel.vue'

export default {
  components: { FeatureGuidePanel },
  data () {
    const now = new Date()
    return {
      year: now.getFullYear(),
      month: now.getMonth() + 1,
      data: {},
      status: {}
    }
  },
  computed: {
    calendarDays () {
      const days = []
      const first = new Date(this.year, this.month - 1, 1)
      const last = new Date(this.year, this.month, 0).getDate()
      let startWeek = first.getDay()
      startWeek = startWeek === 0 ? 6 : startWeek - 1
      for (let i = 0; i < startWeek; i++) days.push({ key: 'e' + i, day: '', mark: '', cls: 'empty' })
      const dayMap = this.data.days || {}
      for (let d = 1; d <= last; d++) {
        const key = String(d).padStart(2, '0')
        const info = dayMap[key] || {}
        days.push({ key: 'd' + d, day: d, mark: info.checked ? '✅' : '', cls: info.checked ? 'checked' : '' })
      }
      return days
    }
  },
  created () {
    this.load()
    this.$ajax.get(newApi.checkinStatus).then(res => { this.status = res || {} }).catch(() => {})
  },
  methods: {
    load () {
      this.$ajax.get(newApi.checkinCalendar + '?year=' + this.year + '&month=' + this.month)
        .then(res => { this.data = res || {} })
        .catch(() => { this.toast('加载失败') })
    },
    toast (msg) {
      if (this.$vux) this.$vux.toast.text(msg)
    },
    prevMonth () {
      if (this.month === 1) { this.year--; this.month = 12 } else this.month--
      this.load()
    },
    nextMonth () {
      if (this.month === 12) { this.year++; this.month = 1 } else this.month++
      this.load()
    },
    doCheckin () {
      this.$ajax.post(newApi.checkinDo, {}).then(res => {
        if (res && res.success) {
          this.toast(res.message || '打卡成功')
          this.load()
          this.$ajax.get(newApi.checkinStatus).then(r => { this.status = r || {} })
        } else {
          this.toast((res && res.message) || '打卡失败')
        }
      }).catch(() => { this.toast('打卡失败') })
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/new/checkin/calendar.vue